import { useCallback } from 'react';
import { redirect } from 'react-router-dom';
import { AppRoutes } from '../constants';
import { OrganizationStatus, SettingsTab } from '../types';
import { useAppSelector } from './index';

/**
 * Returns a Router loader for the Settings page.
 */
const useSettingsLoader = () => {
  const organization = useAppSelector((state) => state.auth.organization);
  const isTrialOrg = organization?.status === OrganizationStatus.TRIAL;
  const isHiringDisabled = !organization?.isHiringModuleEnabled || isTrialOrg;

  const settingsLoader = useCallback(
    ({ request }: { request: Request }) => {
      const url = new URL(request.url);

      // If the user is trying to access a tab that is disabled, redirect to the default tab.
      if (
        (url.pathname.includes(SettingsTab.HIRING) && isHiringDisabled) ||
        (url.pathname.includes(SettingsTab.INTEGRATIONS) && isTrialOrg)
      ) {
        return redirect(AppRoutes.SETTINGS);
      }

      // Otherwise, continue to the requested tab.
      return null;
    },
    [isHiringDisabled, isTrialOrg]
  );

  return settingsLoader;
};

export default useSettingsLoader;
